











import { computed, defineComponent } from "@vue/composition-api";
import { Group } from "@scrile/api-provider/dist/api/GroupsProvider";
import { $t } from "@/lib/i18nHelpers";
import { getMassMessageUrl } from "@/lib/urlHelpers";
import { BaseMenuItem } from "@/types";
import BaseIconButton from "@/components/BaseIconButton";
import BaseMenu from "@/components/BaseMenu";

export default defineComponent({
  name: "GroupMenu",
  components: {
    BaseMenu,
    BaseIconButton,
  },
  props: {
    group: { type: Object as () => Group, required: true },
  },
  setup(props, { root }) {
    const menuItems = computed<BaseMenuItem[]>(() => {
      return [
        ...(props.group.memberCount > 1
          ? [
              {
                name: "sendMassMessage",
                text: $t("Send mass message"),
              },
            ]
          : []),

        ...(props.group.system
          ? []
          : [
              {
                name: "rename",
                text: $t("Rename"),
              },
              {
                name: "delete",
                text: $t("Delete"),
              },
            ]),
      ];
    });

    const sendMassMessage = () => root.$router.push(getMassMessageUrl([props.group.id]));

    return { menuItems, sendMassMessage };
  },
});
